import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const ModalWindowChangeUserPassword = (props) => {
  return (
    <div>
      <Modal
        show={props.isShowWindow}
        onHide={props.onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered={true}
        backdrop={true}
      >
        <Modal.Body>
          <h4 className="mt-2 mb-4">Reset password for '{props.username}'</h4>
          <form>
            {props.errorMsg && (
              <span className="badge text-bg-danger">{props.errorMsg}</span>
            )}
            <div className="mb-3">
              <p>New password, minimum 3 characters</p>
              <input
                type="password"
                className="form-control"
                onChange={props.handleFirstPass}
              ></input>
            </div>
            <div className="mb-3">
              <p>Retype new password</p>
              <input
                type="password"
                className="form-control"
                onChange={props.handleSecondPass}
              ></input>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="large-button grey" onClick={props.onHide}>
            CLOSE
          </button>
          {props.isPassEquals && (
            <button
              type="button"
              onClick={props.handleSubmit}
              className="large-button green"
            >
              RESET PASSWORD
            </button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ModalWindowChangeUserPassword;
